export default __webpack_public_path__ + "static/media/response.37193aaf.svg";